import React from "react";

import { Routes, Route } from "react-router-dom";

import { useUserState } from "contexts/user";
import { getPermissions } from "utils/roleBasedAccess";

import ReferenceSourceExplorePage from "./Explore";
import CrosswalkMapping from "./Explore/CrossWalks/CrosswalkMapping";
import ReferenceSourceHome from "./Home";

const ReferenceSource = ({ features }) => {
  const user = useUserState();

  return (
    <Routes>
      <Route
        path="/"
        element={
          <ReferenceSourceHome
            userPermissions={getPermissions(features, user?.role)}
          />
        }
      />
      <Route
        path=":referenceSourceId/crosswalks/:crosswalkId/crosswalk-mapping"
        element={<CrosswalkMapping />}
      />
      <Route
        path=":referenceSourceId/*"
        element={<ReferenceSourceExplorePage features={features?.explore} />}
      />
    </Routes>
  );
};

export default ReferenceSource;
